import { Button } from "antd";
import { DevelopType } from "./type";
import dataJson from "@/../public/data.json";

import "./index.less";
const prefix = "develop";

function Develop() {
  return (
    <div>
      {dataJson.develop.develop_arr.map((item: DevelopType, index: number) => {
        return (
          <div className={`${prefix} ${index % 2 == 0 ? "even" : "odd"}`} key={index}>
            <div className={`${prefix}-inner ${index % 2 == 0 ? "even" : "odd"}`}>
              <div className={`${prefix}-content`}>
                <div className={`${prefix}-content-title`}>{item.title}</div>
                <div className={`${prefix}-content-describe`}>{item.describe}</div>
                <Button type="primary" shape="round">
                  {dataJson.learn_more}
                </Button>
              </div>
              <img src={item.url} alt="" />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Develop;
